// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import PhotoSlider from '../components/PhotoSlider';

const Home = () => {
  return (
    <div className="relative">
      <PhotoSlider />
      <Hero />
    </div>
  );
};

export default Home;
